import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog'
import { Component, Inject, OnInit } from '@angular/core'

@Component({
    selector: 'app-second-claim-modal',
    templateUrl: './second-claim-modal.component.html',
    styleUrls: ['./second-claim-modal.component.scss'],
    standalone: false
})
export class SecondClaimModalComponent implements OnInit {
  changeclaim: boolean = false
  constructor(
    @Inject(DIALOG_DATA) public data: any,
    private dialogRef: DialogRef<SecondClaimModalComponent>
  ) {}

  ngOnInit(): void {}

  secondClaimbtn(e) {
    this.changeclaim = e.target.value
    this.dialogRef.close({ data: this.changeclaim } as any)
  }
  closeModal() {
    this.dialogRef.close({ data: 'close' } as any)
  }
}
